"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var api_base_1 = __importDefault(require("./api_base"));
exports.default = {
    get: function (organizationId) {
        return api_base_1.default
            .get('accessible_navigation_items', { params: { organization_id: organizationId } })
            .then(function (response) { return response.data.data; });
    }
};
//# sourceMappingURL=navigation_items_api.js.map